import { useEffect, useState, type FormEvent } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/category", label: "影视分类" },
  { to: "/stars", label: "明星资讯" },
  { to: "/special", label: "专题合集" },
  { to: "/about", label: "关于我们" },
  { to: "/contact", label: "联系我们" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const submitSearch = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
    setMenuOpen(false);
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur transition-shadow ${
        scrolled ? "border-b border-background-200" : "border-b border-transparent"
      }`}
    >
      <div className="flex h-16 w-full items-center gap-4 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="text-lg font-black tracking-tight text-foreground-950">激情视频</span>
            <span className="font-display text-[10px] tracking-[0.25em] text-primary-600">
              PASSION VIDEO
            </span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1 mx-auto">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors cursor-pointer ${
                  isActive
                    ? "bg-primary-50 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <form
          onSubmit={submitSearch}
          className="relative hidden md:flex h-10 w-48 lg:w-56 items-center rounded-md border border-background-200 bg-background-100 focus-within:border-primary-400"
        >
          <i className="ri-search-line ml-3 text-foreground-500 text-sm" />
          <input
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜索影片 / 明星"
            className="h-full w-full bg-transparent px-2 text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
          />
        </form>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMenuOpen((v) => !v)}
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 lg:hidden cursor-pointer"
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 lg:hidden">
          <form
            onSubmit={submitSearch}
            className="relative mb-3 flex h-11 w-full items-center rounded-md border border-background-200 bg-background-100 focus-within:border-primary-400"
          >
            <i className="ri-search-line ml-3 text-foreground-500 text-base" />
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影片 / 明星"
              className="h-full w-full bg-transparent px-2 text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
          </form>
          <nav className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2.5 text-sm font-medium transition-colors cursor-pointer ${
                    isActive
                      ? "bg-primary-50 text-primary-700"
                      : "bg-background-100 text-foreground-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}